import { useQuery } from '@tanstack/react-query';
import { BloodPressureClassification } from 'models/bloodpressure';
import { ObjectNotFoundError } from 'services/errors/ObjectNotFoundError';
import { UnknownClassificationError } from 'services/errors/UnknownClassificationError';
import { useGetGeneralConfiguration } from 'hooks/api/configuration/useGetGeneralConfiguration';
import { queryKeys, SCHEMA_NAMES, sdk } from 'utils/query';
import { set } from 'lodash';
import { BloodPressureGuidelinesKeys } from 'utils/measurements/bloodpressure';

const getBloodPressureClassification = async (classificationGuidelineId: string) => {
  const classification = await sdk.data.documents.findById<BloodPressureClassification>(
    SCHEMA_NAMES.bloodPressureClassifications,
    classificationGuidelineId,
  );

  if (!classification) {
    throw new ObjectNotFoundError('Bloodpressure Classification');
  }

  const guidelineName = classification.data.guideline;

  const matchedKey = Object.values(BloodPressureGuidelinesKeys).find((key) =>
    key.split('_').every((part) => guidelineName.includes(part)),
  );

  if (!matchedKey) throw new UnknownClassificationError();

  set(classification, 'data.guideLineKey', matchedKey);

  return classification;
};

export const useGetBloodPressureClassification = () => {
  const { data: generalConfiguration } = useGetGeneralConfiguration();
  const classificationGuidelineId = generalConfiguration?.data?.bloodPressure?.defaultClassificationGuidelineId;

  return useQuery({
    queryKey: [queryKeys.bloodPressureClassifications, classificationGuidelineId],
    queryFn: () => getBloodPressureClassification(classificationGuidelineId!),
    enabled: !!classificationGuidelineId,
  });
};
